<template>
    <modal
        id="report-templates-modal"
        title="Manage Documents"
        ok-title="Close"
        scrollable
        no-fade
        :static="true"
        ok-only
        size="lg"
    >
        <busy-modal :show="busy"></busy-modal>
        <b-tabs pills card>
            <b-tab title="Shortcuts" active>
                <b-card-text>
                    <grid
                        ref="grid"
                        :columnDefs="shortcutsColumnsDefs"
                        :is-search="false"
                        :row-data="values"
                        :isAutoHeight="true"
                    ></grid>
                </b-card-text>
            </b-tab>
            <b-tab title="Visibility">
                <b-card-text>
                    <grid
                        ref="grid"
                        :columnDefs="visibilityColumnsDefs"
                        :is-search="false"
                        :row-data="values"
                        :isAutoHeight="true"
                    ></grid>
                </b-card-text>
            </b-tab>
        </b-tabs>
        
    </modal>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import Grid from '../../generic/grid/grid.vue';
    import {
        RESERVATION_INVOICE_RT_SHORTCUT_ENDPOINT,
        RESERVATION_INVOICE_RT_HIDDEN_ENDPOINT,
    } from '../../../endpoints';    

    export default {
        name: 'ReportTemplatesModal',
        components: {
            BusyModal,
            Modal,
            Grid
        },
        props: {
            reportTemplates: {
                type: Array,
                default: () => [],
            },
            onUpdate: {
                type: Function,
                default: () => {},
            },            
        },  
        data() {
            return {
                busy: false,
                values: [],
                shortcutsColumnsDefs: [                  
                    {
                        field: 'report_name',
                        headerName: 'Name'
                    },
                    {
                        field: 'shortcut',
                        headerName: 'Shortcut',
                        type: 'switchColumn',
                        cellRendererParams: ({ data }) => {
                            return {
                                onChange: async ({ data, node, api }, value) => {
                                    try {
                                        await API.put(
                                            RESERVATION_INVOICE_RT_SHORTCUT_ENDPOINT(),
                                            {
                                                id: data.id,
                                                shortcut: value,
                                            }
                                        );
                                        this.onUpdate();
                                    } catch (e) {
                                        this.errorToast({
                                            text: `Could not set shortcut.`,
                                        });
                                    }
                                },
                                disabled: data.is_default_confirmation || data.is_default_invoice
                            }
                        },
                        maxWidth: 100,
                        minWidth: 100,
                    },                    
                ],
                visibilityColumnsDefs: [               
                    {
                        field: 'report_name',
                        headerName: 'Name'
                    },
                    {
                        field: 'show',
                        headerName: 'Show',
                        type: 'switchColumn',
                        cellRendererParams: ({ data }) => {
                            return {
                                onChange: async ({ data, node, api }, value) => {
                                    try {
                                        await API.put(
                                            RESERVATION_INVOICE_RT_HIDDEN_ENDPOINT(),
                                            {
                                                id: data.id,
                                                hidden: !value,
                                            }
                                        );
                                        this.onUpdate();
                                    } catch (e) {
                                        this.errorToast({
                                            text: `Could not set show.`,
                                        });
                                    }
                                },
                                disabled: data.is_default_confirmation || data.is_default_invoice
                            }
                        },
                        maxWidth: 100,
                        minWidth: 100,
                    },                     
                ],                
                 
            };
        },
        methods: {

        },
        watch: {
            reportTemplates(val) {
                this.values = val;
            }
        }

    };
</script>

<style scoped lang="scss">
    :deep(.card-header) {
        padding: 0.5rem 0.5rem !important;
    }
</style>
